module.exports = __webpack_public_path__ + "summernote.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/summernote/dist/font/summernote.ttf?ad8d7e2d177d2473aecd9b35d16211fb
// module id = 1573
// module chunks = 6